<template>
    <FciDialog :title="this.$f.tc('variable')" :width="400" v-model="show">
        <div class="VariableEditor pa-3">
            <v-form ref="form" v-model="formValid" @submit="submit">
                <v-text-field
                    outlined
                    dense
                    :label="this.$f.tc('variable')"
                    v-model="model.name"
                    :rules="formRules.required"
                ></v-text-field>
                <v-select
                    outlined
                    dense
                    clearable
                    :label="this.$f.tc('entityType')"
                    :items="entityList"
                    item-text="label"
                    item-value="label"
                    v-model="model.entity"
                ></v-select>
                <v-select
                    outlined
                    dense
                    clearable
                    :label="this.$f.tc('subEntity')"
                    :items="subEntityList"
                    item-text="label"
                    item-value="label"
                    v-model="model.subEntity"
                ></v-select>
                <v-select
                    outlined
                    dense
                    :label="this.$f.tc('validation')"
                    :items="variableTypeList"
                    item-text="name"
                    item-value="type"
                    v-model="model.memory_type_id"
                ></v-select>
                <v-layout>
                    <v-flex></v-flex>
                    <v-btn color="primary" type="submit">{{ $f.tc('save') }}</v-btn>
                </v-layout>
            </v-form>
        </div>
    </FciDialog>
</template>

<script>
import DialogEditorMixin from '@/modules/fptai/mixins/DialogEditorMixin'
import { mapState } from 'vuex'

export default {
    name: 'VariableEditor',
    mixins: [DialogEditorMixin],
    data () {
        return {
            model: {
                name: '',
                entity: '',
                subEntity: '',
                memory_type_id: ''
            },
            subEntityList: []
        }
    },
    computed: {
        ...mapState({
            entityList: state => state.scenario.entityList,
            variableTypeList: state => state.scenario.variableTypeList
        })
    },
    methods: {
        onOpen () {
            if (this.item) {
                this.model = {
                    name: this.item.name,
                    entity: this.item.entity,
                    subEntity: '',
                    memory_type_id: this.item.memory_type_id
                }
            } else {
                this.clearForm()
                this.model.memory_type_id = 'text'
            }
        },
        submitValidForm () {
            this.close()
            let model = {
                name: this.model.name,
                entity: null,
                memory_type_id: this.model.memory_type_id
            }
            if (this.model.entity) {
                model.entity = this.model.entity + (this.model.subEntity ? '.' + this.model.subEntity : '')
            } else {
                model.entity = ''
            }
            this.promise.resolve(model)
        }
    },
    watch: {
        'model.entity' () {
            if (this.model.entity) {
                this.subEntityList = this.entityList.find(entity => entity.label === this.model.entity).sub_entities
            } else {
                this.subEntityList = []
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
